import React, { FC } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { appendToUrlPath } from '../../../../utils/link.utils';
import RoutableNotEditableLink from '../../../@shared/routableNotEditableLink';
import { TProductCard } from '../../types/productModelsListing.types';
import SummarySpecs from './summarySpecs';
import PictureBlock from './pictureBlock';
import CtaBlock from './ctaBlock';
import MsrpBlock from './msrpBlock';
import '../../../../styles/@shared/product-card.scss';
import './styles.scss';

const ProductCard: FC<WithTranslation & TProductCard> = (props) => {
  const { title, msrp, summarySpecs, assets, baseUrl, titleUrl, showModelUrl, t } = props;
  const asset = assets?.[0];
  const hasButton = !!(titleUrl && showModelUrl);
  const onClickRedirectionDisabled = !titleUrl || showModelUrl === false;

  return (
    <article className="series-detail-model-listing product-card__wrapper">
      <RoutableNotEditableLink
        href={appendToUrlPath(baseUrl || '', titleUrl || '')}
        onClick={(e): void => {
          onClickRedirectionDisabled && e.preventDefault();
        }}
        className={`${onClickRedirectionDisabled ? 'series-detail-model-listing-none' : ''}`}
      >
        <div className="product-card">
          <div className="product-card__image-wrapper">
            <PictureBlock asset={asset} />
          </div>
          <div className={`product-card__content ${hasButton && 'product-card__content-layout'}`}>
            <div>
              {title ? <h3 className="product-card__title">{title}</h3> : null}
              <div className="product-card__content--msrp-tooltip">
                <MsrpBlock msrp={msrp} t={t} />
              </div>
              {summarySpecs?.length ? <SummarySpecs summarySpecs={summarySpecs} /> : null}
            </div>
            <CtaBlock hasButton={hasButton} baseUrl={baseUrl} titleUrl={titleUrl} t={t} />
          </div>
        </div>
      </RoutableNotEditableLink>
    </article>
  );
};

export default withTranslation()(ProductCard);
